import { configureStore } from "@reduxjs/toolkit";
import tmSlice from "./tmSlice";
import tsSlice from "./tsSlice";


export const store = configureStore({
    reducer:{
        trendingMovies: tmSlice,
        trendingSeries: tsSlice,
    }
})

 